import { render, staticRenderFns } from "./SecondaryVideo.vue?vue&type=template&id=4aaaa83c&scoped=true&lang=pug"
import script from "./SecondaryVideo.vue?vue&type=script&lang=ts"
export * from "./SecondaryVideo.vue?vue&type=script&lang=ts"
import style0 from "./SecondaryVideo.vue?vue&type=style&index=0&id=4aaaa83c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaaa83c",
  null
  
)

export default component.exports